/**
 * @fileOverview This file contains the implementation of the ItemMenu component for Item component of the Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Menu, MenuItem } from '@mui/material';
//#endregion

const ItemMenu = ({
  anchorOptionsMenu,
  menuOpen,
  handleMenuClose,
  setShowMovementModal,
  setShowEditModal,
  setShowDeleteModal
}) => {
  return (
    <Menu
      anchorEl={anchorOptionsMenu}
      open={menuOpen}
      onClose={handleMenuClose}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
    >
      <MenuItem
        onClick={() => {
          setShowMovementModal(true);
          handleMenuClose();
        }}
      >
        Crear orden
      </MenuItem>
      <MenuItem
        onClick={() => {
          setShowEditModal(true);
          handleMenuClose();
        }}
      >
        Editar información
      </MenuItem>
      <MenuItem
        onClick={() => {
          setShowDeleteModal(true);
          handleMenuClose();
        }}
      >
        Eliminar refacción
      </MenuItem>
    </Menu>
  );
};

export default ItemMenu;
